// removed by extract-text-webpack-plugin
module.exports = {"error":"error-tooltip__error-3R77x"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/current-order/bitrix-export-leads/error-tooltip/error-tooltip.css
// module id = 751
// module chunks = 0